export const upgrade = () => (
  <path
    d="M8 12L12 8L16 12M12 8V16M4.30012 5.6286C4.5141 5.37018 4.74046 5.12288 4.9792 4.88669M2.00667 12.3677C2.00223 12.2458 2.00001 12.1232 2.00001 12.0001C1.99869 10.9441 2.16456 9.89461 2.49146 8.89053M5.58018 19.6887C4.3907 18.6911 3.44855 17.4315 2.82767 16.0087M16.6207 20.8735C15.4315 21.4897 14.1311 21.862 12.7959 21.9683C11.4607 22.0746 10.1178 21.9128 8.84605 21.4925M12.0024 2C13.9205 2.00128 15.7978 2.55391 17.4106 3.59204C19.0234 4.63018 20.3038 6.11006 21.0992 7.85537C21.8946 9.60069 22.1715 11.5379 21.8969 13.4361C21.6223 15.3344 20.8078 17.1137 19.5504 18.562"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
